import {EditMenuTypes} from "../pages/types/Menu";

export function formatTimestamp(timestamp: number, format: string = 'YYYY-MM-DD HH:mm:ss') {
    const date = new Date(timestamp);
    const year: number = date.getFullYear();
    const month = addZero(date.getMonth() + 1);
    const day = addZero(date.getDate());
    const hour = addZero(date.getHours());
    const minute = addZero(date.getMinutes());
    const second = addZero(date.getSeconds());

    const formattedDate = format
        .replace(/YYYY/g, String(year))
        .replace(/MM/g, month)
        .replace(/DD/g, day)
        .replace(/HH/g, hour)
        .replace(/mm/g, minute)
        .replace(/ss/g, second);

    return formattedDate;
}

function addZero(num: number) { // 将单个数字转换成两位数格式
    return num < 10 ? `0${num}` : num.toString();
}


export const getCountry = () => {
    const Country = `AD\t安道尔共和国\tAndorra,AE\t阿拉伯联合酋长国\tUnited Arab Emirates,AF\t阿富汗\tAfghanistan,AG\t安提瓜和巴布达\tAntigua and Barbuda\t,AI\t安圭拉岛\tAnguilla\t,AL\t阿尔巴尼亚\tAlbania\t,AM\t亚美尼亚\tArmenia\t,AC \t阿森松\tAscension\t,AO\t安哥拉\tAngola\t,AR\t阿根廷\tArgentina,AT\t奥地利\tAustria,AU\t澳大利亚\tAustralia,AZ\t阿塞拜疆\tAzerbaijan\t,BB\t巴巴多斯\tBarbados,BD\t孟加拉国\tBangladesh\t,BE\t比利时\tBelgium,BF\t布基纳法索\tBurkina-faso\t,BG\t保加利亚\tBulgaria,BH\t巴林\tBahrain,BI\t布隆迪\tBurundi,BJ\t贝宁\tBenin,PS\t巴勒斯坦\tPalestine,BM\t百慕大群岛\tBermuda Is.\t,BN\t文莱\tBrunei\t,BO\t玻利维亚\tBolivia\t,BR\t巴西\tBrazil,BS\t巴哈马\tBahamas\t,BW\t博茨瓦纳\tBotswana\t,BY\t白俄罗斯\tBelarus\t,BZ\t伯利兹\tBelize\t,CA\t加拿大\tCanada\t,KY\t开曼群岛\tCayman Is.\t,CF\t中非共和国\tCentral African Republic\t,CG\t刚果\tCongo\t,CH\t瑞士\tSwitzerland,CK\t库克群岛\tCook Is.\t,CL\t智利\tChile,CM\t喀麦隆\tCameroon\t,CN\t中国\tChina,CO\t哥伦比亚\tColombia,CR\t哥斯达黎加\tCosta Rica\t,CS\t捷克\tCzech\t,CU\t古巴\tCuba,CY\t塞浦路斯\tCyprus,CZ\t捷克\tCzech Republic,DE\t德国\tGermany,DJ\t吉布提\tDjibouti\t,DK\t丹麦\tDenmark,DO\t多米尼加共和国\tDominica Rep.,DZ\t阿尔及利亚\tAlgeria,EC\t厄瓜多尔\tEcuador,EE\t爱沙尼亚\tEstonia,EG\t埃及\tEgypt,ES\t西班牙\tSpain,ET\t埃塞俄比亚\tEthiopia\t,FI\t芬兰\tFinland\t,FJ\t斐济\tFiji,FR\t法国\tFrance,GA\t加蓬\tGabon\t,GB\t英国\tUnited Kiongdom,GD\t格林纳达\tGrenada\t,GE\t格鲁吉亚\tGeorgia\t,GF\t法属圭亚那\tFrench Guiana,GH\t加纳\tGhana,GI\t直布罗陀\tGibraltar,GM\t冈比亚\tGambia\t,GN\t几内亚\tGuinea\t,GR\t希腊\tGreece,GT\t危地马拉\tGuatemala\t,GU\t关岛\tGuam,GY\t圭亚那\tGuyana,HK\t中国香港特别行政区\tHongkong,HN\t洪都拉斯\tHonduras,HT\t海地\tHaiti,HU\t匈牙利\tHungary,ID\t印度尼西亚\tIndonesia,IE\t爱尔兰\tIreland,IL\t以色列\tIsrael,IN\t印度\tIndia,IQ\t伊拉克\tIraq,IR\t伊朗\tIran,IS\t冰岛\tIceland,IT\t意大利\tItaly,CI\t科特迪瓦\tIvory Coast,JM\t牙买加\tJamaica,JO\t约旦\tJordan,JP\t日本\tJapan,KE\t肯尼亚\tKenya,KG\t吉尔吉斯坦\tKyrgyzstan,KH\t柬埔寨\tKampuchea (Cambodia ),KP\t朝鲜\tNorth Korea,KR\t韩国\tKorea,KW\t科威特\tKuwait,KZ\t哈萨克斯坦\tKazakstan,LA\t老挝\tLaos,LB\t黎巴嫩\tLebanon,LC\t圣卢西亚\tSt.Lucia,LI\t列支敦士登\tLiechtenstein,LK\t斯里兰卡\tSri Lanka,LR\t利比里亚\tLiberia,LS\t莱索托\tLesotho,LT\t立陶宛\tLithuania,LU\t卢森堡\tLuxembourg,LV\t拉脱维亚\tLatvia,LY\t利比亚\tLibya,MA\t摩洛哥\tMorocco,MC\t摩纳哥\tMonaco,MD\t摩尔多瓦\tMoldova Republic of,MG\t马达加斯加\tMadagascar,ML\t马里\tMali,MM\t缅甸\tBurma,MN\t蒙古\tMongolia,MO\t中国澳门特别行政区\tMacao,MS\t蒙特塞拉特岛\tMontserrat Is,MT\t马耳他\tMalta,MP\t马里亚那群岛\tMariana Is,MQ\t马提尼克\tMartinique,MU\t毛里求斯\tMauritius,MV\t马尔代夫\tMaldives,MW\t马拉维\tMalawi,MX\t墨西哥\tMexico,MY\t马来西亚\tMalaysia,MZ\t莫桑比克\tMozambique,NA\t纳米比亚\tNamibia,NE\t尼日尔\tNiger,NG\t尼日利亚\tNigeria,NI\t尼加拉瓜\tNicaragua,NL\t荷兰\tNetherlands,NO\t挪威\tNorway,NP\t尼泊尔\tNepal,AN\t荷属安的列斯\tNetheriands Antilles,NR\t瑙鲁\tNauru,NZ\t新西兰\tNew Zealand,OM\t阿曼\tOman,PA\t巴拿马\tPanama,PE\t秘鲁\tPeru,PF\t法属玻利尼西亚\tFrench Polynesia,PG\t巴布亚新几内亚\tPapua New Cuinea,PH\t菲律宾\tPhilippines,PK\t巴基斯坦\tPakistan,PL\t波兰\tPoland,PR\t波多黎各\tPuerto Rico,PT\t葡萄牙\tPortugal,PY\t巴拉圭\tParaguay,QA\t卡塔尔\tQatar,RE\t留尼旺\tReunion,RO\t罗马尼亚\tRomania,RU\t俄罗斯\tRussia,SA\t沙特阿拉伯\tSaudi Arabia,SB\t所罗门群岛\tSolomon Is,SC\t塞舌尔\tSeychelles,SD\t苏丹\tSudan,SE\t瑞典\tSweden,SG\t新加坡\tSingapore,SI\t斯洛文尼亚\tSlovenia,SK\t斯洛伐克\tSlovakia,SL\t塞拉利昂\tSierra Leone,SM\t圣马力诺\tSan Marino,AS\t东萨摩亚(美)\tSamoa Eastern,WS\t西萨摩亚\tSan Marino,SN\t塞内加尔\tSenegal,SO\t索马里\tSomali,SR\t苏里南\tSuriname,ST\t圣多美和普林西比\tSao Tome and Principe,SV\t萨尔瓦多\tEI Salvador,SY\t叙利亚\tSyria,SZ\t斯威士兰\tSwaziland,TD\t乍得\tChad,TG\t多哥\tTogo,TH\t泰国\tThailand,TJ\t塔吉克斯坦\tTajikstan,TM\t土库曼斯坦\tTurkmenistan,TN\t突尼斯\tTunisia,TO\t汤加\tTonga,TR\t土耳其\tTurkey,TT\t特立尼达和多巴哥\tTrinidad and Tobago,TW\t中国台湾省\tTaiwan,TZ\t坦桑尼亚\tTanzania,UA\t乌克兰\tUkraine,UG\t乌干达\tUganda,US\t美国\tUnited States of America,UY\t乌拉圭\tUruguay\t,UZ\t乌兹别克斯坦\tUzbekistan\t,VC\t圣文森特岛\tSaint Vincent,VE\t委内瑞拉\tVenezuela,VN\t越南\tVietnam,YE\t也门\tYemen\t,YU\t南斯拉夫\tYugoslavia,ZA\t南非\tSouth Africa,ZM\t赞比亚\tZambia,ZR\t扎伊尔\tZaire,ZW\t津巴布韦\tZimbabwe`.split(',').map((item: any)=>{
        item = item.split('\t');
        return {
            id: item[0],
            text: item[1] + `(${item[2]})`
        }
    });
    return Country;
}

export const getCountryName = (ids: string[]) => {
    const country_list = getCountry();
    const country_name_list: string[] = []
    country_list.map((v: any) => {
        if (ids.includes(v.id)) {
            country_name_list.push(v.text)
        }
    })
    return country_name_list.join(", ")
}

// 合并数组
export const mergeArr = (first: any[], second: any[]) => {
    return first.concat(second).reduce((prev, curr) =>
        prev.includes(curr) ? prev : [...prev, curr], []
    );
}

export function isObject(obj: any) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}


export const deepClone = (value: any) => {
    if (typeof value !== 'object' || value === null) {
        return value;
    }

    let clonedObject: any;
    if (Array.isArray(value)) {
        clonedObject = [];
        for (let i = 0; i < value.length; i++) {
            clonedObject.push(deepClone(value[i]));
        }
    } else {
        clonedObject = {};
        for (let key in value) {
            if (value.hasOwnProperty(key)) {
                clonedObject[key] = deepClone(value[key]);
            }
        }
    }

    return clonedObject;
};

export const getMediaFromCampaignId = (ids: string[], list: any[]) => {
    const media_list: string[] = [];
    list.forEach((v: any) => {
        if (ids.includes(v.value) && !media_list.includes(v.media_source)) {
            media_list.push(v.media_source)
        }
    })
    return media_list;
}

export const getAfStatusFromMedia = (value: string, list: any[]) => {
    const item = list.find((v: any) => v.value === value);
    return item && item.af_status;
}

export const getNextLetter = (letter: string) => {
    return String.fromCharCode(letter.charCodeAt(0) + 1);
}

export const getTreeChildIdList = (menuTree: EditMenuTypes[]) => {
    // 存储二级子节点的 ID 的数组
    const secondLevelIds: number[] = [];

    // 递归函数来获取菜单树的二级子节点的 ID
    const getSecondLevelIds = (menu: EditMenuTypes) => {
        if (menu.children && menu.children.length > 0) {
            // 遍历子菜单
            for (const child of menu.children) {
                if (child.children && child.children.length === 0) {
                    // 如果子菜单没有孩子节点，说明是二级子节点，将其 ID 存入数组
                    secondLevelIds.push(child.id);
                } else {
                    // 递归调用，继续遍历下一级子菜单
                    getSecondLevelIds(child);
                }
            }
        }
    };

    // 调用获取二级子节点的 ID 的函数
    for (const menu of menuTree) {
        getSecondLevelIds(menu);
    }
    return secondLevelIds;
}

export const compareChangeKeys = (objA: any, objB: any) => {
    const changedKeys = [];

    for (const key in objA) {
        if (typeof objA[key] === 'object' && typeof objB[key] === 'object') {
            const subKeys = compareChangeKeys(objA[key], objB[key]);

            if (subKeys.length > 0) {
                changedKeys.push(key);
            }
        } else if (objA[key] !== objB[key]) {
            changedKeys.push(key);
        }
    }

    return changedKeys;
}
